// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__7yfBr","label":"CategoryService_label__Vh45r","location":"CategoryService_location__2lDEb"};